import { AddCircleIcon, Link, LinkSize, StyledMaxWidth, Table } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import {
   useCustomPatientGroupsTableColumnsConfiguration,
   useCustomPatientGroupsTableDataConfiguration,
} from './CustomPatientGroupsTable.hooks';
import { CustomPatientGroupsTableEmptyStatePlaceholder } from './CustomPatientGroupsTableEmptyStatePlaceholder';
import { CustomPatientGroupsCreateModalOpener } from './create/CustomPatientGroupsCreateModal.opener';

export const CustomPatientGroupsTable = (): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={'500px'}>
         <Table
            testId={'customPatientGroups'}
            dataConfiguration={useCustomPatientGroupsTableDataConfiguration()}
            columns={useCustomPatientGroupsTableColumnsConfiguration()}
            keyExtractor={'id'}
            placeholder={<CustomPatientGroupsTableEmptyStatePlaceholder />}
            compact
            bottomElement={
               <CustomPatientGroupsCreateModalOpener>
                  {({ openModal }) => (
                     <Link
                        testId={'createCustomPatientGroupLink'}
                        onClick={openModal}
                        label={translationKeys.addGroup}
                        size={LinkSize.NORMAL}
                        icon={<AddCircleIcon />}
                     />
                  )}
               </CustomPatientGroupsCreateModalOpener>
            }
         />
      </StyledMaxWidth>
   );
};
